import React from 'react'
import { TargetTypeIcon } from '../../components'
import { WemoloTypography } from '../../components/Wemolo'
import { SearchItem } from './useGlobalSearchData'
import styles from './SearchResultItem.module.css'

interface SearchResultItemProps {
    item: SearchItem
    index: number
    selectedIndex: number
    onSelect: (item: SearchItem) => void
    resultRef: (el: HTMLLIElement | null) => void
}

export const SearchResultItem: React.FC<SearchResultItemProps> = ({
    item,
    index,
    selectedIndex,
    onSelect,
    resultRef
}) => {
    const buttonClass = index === selectedIndex ? `${styles.button} ${styles.selected}` : styles.button

    return (
        <li key={`${item.type}-${item.id}`} ref={resultRef}>
            <button onClick={() => onSelect(item)} className={buttonClass}>
                <div className={styles.info}>
                    <TargetTypeIcon type={item.type} deviceType={item.deviceType ?? undefined} />
                    <div>
                        <WemoloTypography variant="title-medium" tag="p" className={styles.name}>
                            {item.name}
                        </WemoloTypography>
                        <WemoloTypography variant="body-small" tag="p" className={styles.description}>
                            {item.description}
                        </WemoloTypography>
                    </div>
                </div>
            </button>
        </li>
    )
}
